import React, { useEffect } from "react";
import { ReactComponent as TopBackground } from "../../assets/img/battleAndBuild/topBackground.svg";
import { ReactComponent as TopBackgroundSmall } from "../../assets/img/battleAndBuild/topBackgroundSmall.svg";
import { ReactComponent as MeetOutTeamTop } from "../../assets/img/battleAndBuild/gameModesTop.svg";
import { ReactComponent as MeetOutTeamBottom } from "../../assets/img/aboutUs/meetOutTeamBottom.svg";

import AdelLaggoune from "../../assets/img/aboutUs/AdelLaggoune.png";
import VeeePham from "../../assets/img/aboutUs/VeeePham.jpg";
import AntonFirko from "../../assets/img/aboutUs/AntonFirko.png";
import ArasGonul from "../../assets/img/aboutUs/ArasGonul.png";
import CarolineSharpe from "../../assets/img/aboutUs/CarolineSharpe.png";
import David10X from "../../assets/img/aboutUs/David10X.png";
import IlyaFomenko from "../../assets/img/aboutUs/IlyaFomenko.png";
import JuliyaRudenko from "../../assets/img/aboutUs/JuliyaRudenko.png";
import KyleKlemmer from "../../assets/img/aboutUs/KyleKlemmer.png";
import NikRudenko from "../../assets/img/aboutUs/NikRudenko.png";
import PauloSumaoi from "../../assets/img/aboutUs/PauloSumaoi.png";
import PavleFilipovic from "../../assets/img/aboutUs/PavleFilipovic.png";
import TimofeiMolokov from "../../assets/img/aboutUs/TimofeiMolokov.png";
import TreySmith from "../../assets/img/aboutUs/TreySmith.png";
import VirnadethPachejo from "../../assets/img/aboutUs/VirnadethPachejo.png";
import VolodymyrDiamandi from "../../assets/img/aboutUs/VolodymyrDiamandi.png";

import styles from "./aboutUs.module.css";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.aboutUsTop}>
        <TopBackground className={styles.topBackgroundSvg} />
        <TopBackgroundSmall className={styles.topBackgroundSmallSvg} />
        <div className={styles.aboutUsBlock}>
          <h2>ABOUT US</h2>
          <div>
            Welcome to Mech! We're a team of misfit tech geeks and gaming
            fanatics who believe that everyone should have access to the
            ultimate gaming experience, without having to sell an arm and a leg
            for it. That's why we created Mech, a virtual universe where you can
            let your imagination run wild and build anything you can dream of
            using our state-of-the-art AI-made Mechs and Creator Tools.
            <br />
            <br />
            Our team of experts, led by founder Trey Smith, have been
            revolutionizing tech and creating amazing video games for over 10
            years. We're proud to say that we're constantly pushing the
            boundaries of what's possible, and we're passionate about making the
            Mech universe an immersive and unforgettable experience
            <br />
            <br />
            We know that gaming can be more than just a pastime. It's a way to
            connect, explore, and express yourself in a way that's uniquely your
            own. That's why we've designed Mech to be more than just a game.
            It's a place where you can create amazing games, build unique NFT
            buildings, and craft in-game assets that the whole community can
            enjoy.
            <br />
            <br />
            We believe in the power of collaboration and creativity, which is
            why we want to give you the tools to build anything you can imagine,
            without any previous coding knowledge required. And you shouldn’t
            have to break the bank for it. We know that not everyone has an
            unlimited budget, which is why we gave away 10000 Bots for free.
            Everyone should have the opportunity to play our game and experience
            the thrills it offers.
            <br />
            With just a few clicks, you can turn your piece of land into the
            next big game in the Mech universe. So come join us in the Mech
            revolution and build the gaming world of your dreams.
            <div className={styles.aboutUsBlockTopLine} />
          </div>
        </div>
      </div>
      <div className={styles.meetOurTeam}>
        <MeetOutTeamTop className={styles.meetOutTeamTopSvg} />
        <div className={styles.meetOurTeamTextBlock}>
          <h2>MEET OUT TEAM</h2>
          <div className={styles.meetOutTeamInfo}>
            We're always looking to grow and impove our team. If you feel like
            you and your skills can contribute to Mech, feel free to shoot us an
            email.
          </div>
        </div>
        <div className={styles.teamBlock}>
          <div className={styles.teamBlockItem}>
            <img src={TreySmith} alt="Trey Smith image" />
            <h2>CEO</h2>
            <div>Trey Smith</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={NikRudenko} alt="Nik Rudenko image" />
            <h2>CTO</h2>
            <div>Nik Rudenko</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={KyleKlemmer} alt="Kyle Klemmer image" />
            <h2>COO</h2>
            <div>Kyle Klemmer</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={CarolineSharpe} alt="Caroline Sharpe image" />
            <h2>Project Manager</h2>
            <div>Caroline Sharpe</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={PavleFilipovic} alt="Pavle Filipovic image" />
            <h2>Director of Marketing</h2>
            <div>Pavle Filipovic</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={VirnadethPachejo} alt="Virnadeth Pachejo image" />
            <h2>Operations</h2>
            <div>Virnadeth Pachejo</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={PauloSumaoi} alt="Paulo Sumaoi image" />
            <h2>SMM</h2>
            <div>Paulo Sumaoi</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={AdelLaggoune} alt="Adel Laggoune image" />
            <h2>Developer</h2>
            <div>Adel Laggoune</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={AntonFirko} alt="Anton Firko image" />
            <h2>Developer</h2>
            <div>Anton Firko</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={ArasGonul} alt="Aras Gonul image" />
            <h2>Developer</h2>
            <div>Aras Gonul</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={David10X} alt="David 10X image" />
            <h2>Head of Community Dev.</h2>
            <div>David 10X</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={IlyaFomenko} alt="Ilya Fomenko image" />
            <h2>Developer</h2>
            <div>Ilya Fomenko</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={VeeePham} alt="Veee Pham image" />
            <h2>Executive Assistant</h2>
            <div>Veee Pham</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={TimofeiMolokov} alt="Timofei Molokov image" />
            <h2>Developer</h2>
            <div>Timofei Molokov</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={VolodymyrDiamandi} alt="Volodymyr Diamandi image" />
            <h2>Developer</h2>
            <div>Volodymyr Diamandi</div>
          </div>
          <div className={styles.teamBlockItem}>
            <img src={JuliyaRudenko} alt="Juliya Rudenko image" />
            <h2>Administration</h2>
            <div>Juliya Rudenko</div>
          </div>
        </div>
        <MeetOutTeamBottom className={styles.meetOutTeamBottomSvg} />
      </div>
    </div>
  );
};

export default AboutUs;
